var router = require('pjax').Router;
var form = require('./form.js');
var review = require('./review.js');

router.get('broadcast/:any', form);
router.get('broadcast/:any/review', review);
